import {
    GET_EXPENSE_CONFIG,
    GET_EXPENSE_TYPES,
    SET_EXPENSE_TYPES,
    SAVE_EXPENSE_CONFIG
} from './action-types';

import {
    GET_EXPENSE_CONFIG_URL,
    GET_EXPENSE_TYPES_URL,
    SAVE_EXPENSE_CONFIG_URL
} from '../utils/api-url';
import { getCall, postCall } from "../utils/network.util";

export const getExpenseConfigByOperatorCode = (operatorCode) => {
    return {
        type: GET_EXPENSE_CONFIG,
        payload: {
            url: GET_EXPENSE_CONFIG_URL,
            api: postCall,
            apiPayload: {
                operatorCode: operatorCode
            }
        }
    }
}

export const getExpenseTypes = () => {
    return {
        type: GET_EXPENSE_TYPES,
        payload: {
            url: GET_EXPENSE_TYPES_URL,
            api: getCall
        }
    }
}

export const saveExpenseConfig = (operatorCode, expenseConfig) => {
    return {
        type: SAVE_EXPENSE_CONFIG,
        payload: {
            url: SAVE_EXPENSE_CONFIG_URL,
            api: postCall,
            apiPayload: {
                operatorCode: operatorCode,
                expenseConfig: expenseConfig
            }
        }
    }
}

export const setExpenseTypes = (expenseTypes) => {
    return {
        type: SET_EXPENSE_TYPES,
        payload: {
            expenseTypes: expenseTypes
        }
    }
}
